import {AdminEbayListingStatus} from '../../../../../gen/api/models';

/** eBay condition names by the Inventory API value, for conditions the category list does not name. */
export const CONDITION_LABEL: Record<string, string> = {
    NEW: 'New',
    NEW_OTHER: 'New other / Open box',
    NEW_WITH_DEFECTS: 'New with defects',
    CERTIFIED_REFURBISHED: 'Certified refurbished',
    EXCELLENT_REFURBISHED: 'Excellent - Refurbished',
    VERY_GOOD_REFURBISHED: 'Very good - Refurbished',
    GOOD_REFURBISHED: 'Good - Refurbished',
    SELLER_REFURBISHED: 'Seller refurbished',
    LIKE_NEW: 'Like new',
    PRE_OWNED_EXCELLENT: 'Pre-owned - Excellent',
    USED_EXCELLENT: 'Used',
    PRE_OWNED_FAIR: 'Pre-owned - Fair',
    USED_VERY_GOOD: 'Used - Very good',
    USED_GOOD: 'Used - Good',
    USED_ACCEPTABLE: 'Used - Acceptable',
    FOR_PARTS_OR_NOT_WORKING: 'For parts or not working',
};

/** Conditions offered before a category is chosen; the category narrows them. */
export const COMMON_CONDITIONS = ['NEW', 'NEW_OTHER', 'LIKE_NEW', 'USED_EXCELLENT', 'FOR_PARTS_OR_NOT_WORKING'];

export const conditionLabel = (condition?: string) => (condition ? (CONDITION_LABEL[condition] ?? condition) : '—');

export const LISTING_STATUS: Record<AdminEbayListingStatus, {label: string; color: string}> = {
    draft: {label: 'Draft', color: 'default'},
    publishing: {label: 'Publishing', color: 'processing'},
    active: {label: 'Live', color: 'green'},
    updating: {label: 'Updating', color: 'processing'},
    ending: {label: 'Ending', color: 'processing'},
    ended: {label: 'Ended', color: 'default'},
    sold: {label: 'Sold', color: 'blue'},
    error: {label: 'Failed to publish', color: 'red'},
};
